/*

Dear maintainer,

I am using a CSS approach called BassCss (basscss.com)

Which means I use multiple classes to compose one component's appearance.

With it, I can reduce a lot of CSS defs and styled-components in my code.

I used to create a CSS container just for 2 lines of CSS (margin, fixed), with Basscss not anymore!

Also, I can make sure things such as font-size / line-height and even margins are consistent, for better vertical rhythms.

There're a few downsides of this approach.

1. You can't get very precise on numbers -- for example there are only 4 levels of margins and paddings.

   If you want something like 3.027em, you still need to write that in manually. (in JS/Styled-Components/CSS)

   This is fine for this mostly generic 12-col website. Basscss won't work when you have a highly stylized website.

2. Related to above, it is tricky to "compose" the right number out of the 4 levels of margins.

3. Since they are static css files, you can't use JS variables in them.

   That is why I did not use any responsive definition of it. (I use react-grid-system instead)

   Workaround will be CSS variables (but beware of browser compatibility)

   Or define the related ones below. For example .btn class and .no-gutter class

Finally, my favorite part of this setup:

.h1 ~ .h5 font-size settings in type-scale.css

.cap / line-height settings in typography.css

I hope you enjoy these too.

 */

// reset as usual
import "./reset.css";

// files from basscss.com (modified a little bit here and there)
import "./align.css";
import "./border.css";
import "./flexbox.css";
import "./grid.css";
import "./hide.css";
import "./layout.css";
import "./margin.css";
import "./padding.css";
import "./position.css";
import "./type-scale.css";
import "./typography.css";
import "./icons.css";
import "./animations.css";

import { injectGlobal } from "styled-components";
import { color, gutterWidth, typography } from "./Variables.js";

import WIZARD_BG from './../Wizard/img/bg.svg'

injectGlobal`
html {
	min-height: 100%;
}
body {
	font-family: "Montserrat", sans-serif;
	&.wizard {
		background-color: #def3ee;
		/*background-color: ${color.light_blue_grey};*/
		background-image: url(${WIZARD_BG});
		background-repeat: no-repeat;
		background-size: cover;
	}
}

p {
	font-weight: 400;
	line-height: 1.5;
}

button,
.btn {
	background: ${color.tealish_two};
	border: 0;
	border-radius: 10em;
	color: ${color.white};
	cursor: pointer;
	display: inline-block;
	font-size: 1rem;
	font-weight: 400;
	text-align: center;
	text-decoration: none;
	/* padding: 0.75rem 3rem; */
	padding: 0.75rem 2.1rem;

	&.noHover {
		background: ${color.tealish_two};
	color: ${color.white};

	}

	&:hover {
		background: ${color.light_turquoise};
	}
	outline: none;
	&:focus,
	&:active {
		color: ${color.white};
		background: ${color.lighter_turquoise};
	}
	transition background .3s ease;

	&-white {
		background: ${color.white};
		color: ${color.tealish_two};

		&:hover {
			color: ${color.white};
		}
	}

	&-alt {
		background: transparent;
		box-shadow: inset 0px 0px 0px 1px #fff;

		&:hover {
			background: ${color.white};
			color: ${color.turquoise};
		}
	}

	@media (max-width: 900px) {
		font-weight: 600;
	}
}

a {
	color: ${color.turquoise};
	text-decoration: none;
	transition: color 0.4s ease;
	&:focus {
		outline: none;
		color: ${color.lighter_turquoise};
	}
}

.no-gutter {
	margin-left: ${gutterWidth / -2}px;
	margin-right: ${gutterWidth / -2}px;
}

.hover-underline:hover {
	text-decoration: underline;
}

.pointer {
	cursor: pointer;
}

@media (max-width:900px) {
	.bg-m-none {
		background-color: transparent!important;
	}
}
`;

//
//
//

injectGlobal`
body {
	${typography.size.css('font-size')}
}
`

//
// Make each defined color a class for background-color and color
//

injectGlobal([Object.keys(color).reduce((acc,key)=>{
	const split = key.split('_');
	const name = split.length > 1 ? split.reduce((acc,str)=>`${acc}${str[0]}`,'') : key;
	const _color = color[key]
	return `
		${acc}
		.bg-${name}{
			background-color: ${_color};
		}
		.color-${name}{
			color: ${_color};
		}
		.hover-bg-${name}:hover {
			background-color: ${_color};
		}
		.hover-color-${name}:hover {
			color: ${_color}
		}
		.hover-pointer {
			cursor: pointer;
		}
	`
},"")])

injectGlobal([Object.keys(color).reduce((acc,key)=>{
	const split = key.split('_');
	const name = split.length > 1 ? split.reduce((acc,str)=>`${acc}${str[0]}`,'') : key;
	const _color = color[key]
	return `
		${acc}
		@media (max-width: 900px) {
			.color-m-${name}{
				color: ${_color};
			}

			.bg-m-${name} {
				background-color: ${_color};
			}
		}
	`
},"")])



// WEBPACK FOOTER //
// ./src/style/Global.js